/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import isArray from 'lodash/isArray';
import isRegExp from 'lodash/isRegExp';
import React from 'react';
import has from 'lodash/has';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { generateIteratorKey as keygen } from '../../utils/helpers';

class TcBreadcrumbService {
  /**
   * @description used to filter the breadcrumb paths defined in a flow
   *
   * @param patterns - can be an array of regexp objects of a single regexp against
   * of which to test the current url.
   * @param url - current page url
   * @returns {boolean}
   */
  static testPattern(patterns, url) {
    let match = false;

    if (isArray(patterns)) {
      match = TcBreadcrumbService.testInArray(patterns, url);
    }

    if (isRegExp(patterns)) {
      match = patterns.test(url);
    }

    return match;
  }

  /**
   * @description test a url in an array of regexp objects
   *
   * @param patterns
   * @param url
   * @returns {boolean}
   */
  static testInArray(patterns, url) {
    for (let pattern of patterns) {
      if (pattern.test(url)) {
        return true;
      }
    }
    return false;
  }

  static isLastPath(i, paths) {
    return i == paths.length - 1;
  }

  static createBreadcrumbItem(name, href, state, isLastPath) {
    let active = false;
    if (isLastPath) {
      active = true;
    }

    return (
      <Breadcrumb.Item {...keygen()} active={active}>
        <Link
          className="link tc-breadcrum-path"
          to={{
            pathname: href,
            state: { forBreadcrumb: state }
          }}
        >
          {name}
        </Link>
      </Breadcrumb.Item>
    );
  }

  /**
   * @description create react objects for breadcrumb component from the paths objects
   * @param paths
   */
  static buildBreadcrumb(paths) {
    return paths.map((val, i) => {
      let name = val.name;

      const isLastPath = TcBreadcrumbService.isLastPath(i, paths),
        href = null != val.state ? val.hrefFn(val.state) : val.hrefFn({});

      if (has(val, 'fromState')) {
        if (has(val.state, val.fromState)) {
          name = val.state[val.fromState];
        }
      }

      return TcBreadcrumbService.createBreadcrumbItem(name, href, val.state, isLastPath);
    });
  }
}

export default TcBreadcrumbService;
